export const fillLevelThresholds = {
    high: 0.75,
    low: 0.4,
}
